



<div class=" margin-top">
      <div class="card">      
        <div class="row d-flex p-3 m-0 border-bottom">          
        </div>
        <div class="row p-3 m-0 border-bottom">
          <div class="col-12 p-0 mb-2">
            <div class="row " style="margin-top: -14px;">      
        <div class="col-12 col-md-4 col-lg-4">
          <div class="pr-2">
            <span class="secondaryInfo">File Type *</span>
          </div>
          <select class="form-control" [(ngModel)]="selectedValue" name="fileType" #fileType="ngModel" required (ngModelChange)="onSelected()">
            <option [ngValue]="undefined" [disabled]="true">--Select File Type--</option>
            <option value="Questions">Questions</option>
            <option value="Assumptions">Assumptions</option>
            <option value="Scope IN">Scope IN</option>
            <option value="Scope Out">Scope Out</option>
          </select>
          <div *ngIf="fileType.invalid && (fileType.dirty || fileType.touched)" class="text-danger">
            <div class="error" *ngIf="fileType.errors.required">
              File Type is required.
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4 col-lg-4">
          <div class="pr-2">
            <span class="secondaryInfo">Proposals *</span>
          </div>
          <select class="form-control" [(ngModel)]="proposalValue" name="proposal" #proposal="ngModel" required (ngModelChange)="proposalChange()">
            <option [ngValue]="undefined" disabled selected>--Select Proposal--</option>
            <option [value]="'All Proposals'">All Proposals</option>
            <option *ngFor="let proposal of customerNames" [value]="proposal">{{ proposal }}</option>
          </select>
          <div *ngIf="proposal.invalid && (proposal.dirty || proposal.touched)" class="text-danger">
            <div class="error" *ngIf="proposal.errors.required">
              Please select a proposal.
            </div>
          </div>
        </div>
        
        <div class="col-12 col-md-4 col-lg-4">
          <div class="pr-2">
            <span class="secondaryInfo">Vertical *</span>
          </div>
          <select class="form-control" [(ngModel)]="domainValue" name="domain" #domain="ngModel" required (ngModelChange)="domainChange()">
            <option [ngValue]="undefined" disabled selected>--Select Vertical--</option>
            <option [value]="'All Domains'">All Domains</option>
            <option *ngFor="let category of domains" [value]="category">{{ category }}</option>
          </select>
          <div *ngIf="domain.invalid && (domain.dirty || domain.touched)" class="text-danger">
            <div class="error" *ngIf="domain.errors.required">
              Please select a vertical.
            </div>
          </div>
        </div>   
        <div class="my-button">       
          <button class="btn btn-primary" (click)="exportData()" [disabled]="!areAnyCheckboxesSelected()">Export {{selectedValue}}</button>
        </div>

        <div class="questionsView fixTableHead" *ngIf="selectedData.length > 0">
         
          <table class="custom-table">
            <thead class="table-head">
              <tr>
                <th class="No"><input type="checkbox" (change)="selectAll($event.target.checked)" [checked]="isAllSelected()"></th>
                <th class="question-name">{{selectedValue}}</th> 
                <th class="question-proposal">Proposal</th>         
                <th class="question-domain">Vertical</th>                            
            </thead>
            <tbody>
              <tr *ngFor="let item of selectedData">
                <td><input type="checkbox" [(ngModel)]="item.selected" (change)="checkAllSelected()"></td>
                <td>{{ item.data }}</td>
                <td>{{ item.proposal }}</td>
                <td>{{ item.domain }}</td>
              </tr>
              
            </tbody>
          </table>
        </div>

    

        </div>
        </div>
        </div>
       

        </div>

        </div>
      
       